<template>
  <div class="do-button__multiple no-print">
    <button :content="tooltipArrowLeft"
            v-tippy="{
                 placement: 'bottom',
                 zIndex: 1212121212,
               }" class="do-button__multiple__bttn icon-arrow-left4 no-print"
            @click="$emit('prev')"></button>
    <button class="no-print do-button__multiple__bttn"
            @click="$emit('today')"
            :class="{'bttn--disabled': isToday}">
      I dag
    </button>
    <button :content="tooltipArrowRight"
            v-tippy="{
                 placement: 'bottom',
                 zIndex: 1212121212,
               }" class="do-button__multiple__bttn icon-arrow-right4 " @click="$emit('next')"></button>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    date: {
      default: moment()
    }
  },
  computed: {
    isToday () {
      return moment(this.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
    },
    tooltipArrowLeft () {
      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>←</span></p>'
    },
    tooltipArrowRight () {
      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>→</span></p>'
    },
    metaKey () {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
      return isMac ? '⌘' : 'CTRL'
    }
  }
}
</script>

<style scoped>
.do-button__multiple {
  display: flex;
  justify-content: stretch;
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, .12) 0px 1px 1px 0px, rgba(64, 68, 82, .16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(64, 68, 82, .08) 0px 2px 5px 0px;
  border: 0;
  background: #fff;
  font-weight: 600;
  letter-spacing: .025em;
  border-radius: 4px;
}

.do-button__multiple > .do-button__multiple__bttn {
  text-align: center;
  padding: 2px 10px;
  font-weight: bold !important;
  height: 28px;
  cursor: pointer;
  background: #ffffff;
  border: none;
}

.do-button__multiple > .do-button__multiple__bttn:hover {
  background: #f9fafb;
}

.do-button__multiple > .do-button__multiple__bttn:focus {
  position: relative;
  z-index: 1;
}

.do-button__multiple > .do-button__multiple__bttn:nth-child(2) {
  border: 1px solid #ccc;
  border-radius: 0;
  border-width: 0 1px;
}

.do-button__multiple > .do-button__multiple__bttn.bttn--disabled {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// DoChangeDayNav.vue?f20c1f56